var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabAssistant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 188.8,
    r: 158.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468.3,319.8c-35.9,38.1-86.8,61.9-143.3,61.9c-56.5,0-107.4-23.8-143.3-61.9C119.8,364.4,79.5,437.1,79.5,519.2 c0,12.1,0.9,24,2.6,35.6c71.5,41.3,154.5,64.9,243,64.9s171.5-23.6,243-64.9c1.7-11.6,2.6-23.5,2.6-35.6 C570.5,437.1,530.2,364.4,468.3,319.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabAssistant);
export default __webpack_public_path__ + "static/media/LabAssistant.87c44db5.svg";
export { ForwardRef as ReactComponent };